import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { LinkButton } from 'src/design/atoms/LinkButton';

export interface ISafetyFormCardProps {
  name: string;
  description?: string;
  url: string;
  highlighted?: boolean;
}

export const SafetyFormCard: React.FC<ISafetyFormCardProps> = ({
  name,
  description,
  url,
  highlighted,
}) => {
  return (
    <Paper
      style={
        highlighted
          ? { borderLeft: '4px solid var(--mantine-primary-color-filled)' }
          : undefined
      }
    >
      <Stack gap="xs">
        <Title order={4}>{name}</Title>
        {description && <Text>{description}</Text>}
        <Group justify="flex-end">
          <LinkButton to={url} target="_blank">
            Open Form
          </LinkButton>
        </Group>
      </Stack>
    </Paper>
  );
};
